import { mapGetters } from 'vuex'
import ActionButton from '@/components/ActionButton'
import Message from '@/components/SignupInfoMessage'
import ProgressBar from '@/components/ProgressBar'

export default {
  name: 'SignupKycStep2',
  components: { ActionButton, Message, ProgressBar },
  props: [],
  data () {
    return {
      incorrectDateFormat: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'userDetails',
      appliedToDmi: 'appliedToDmi',
      invalidPinCode: 'invalidPersonalPinCode'
    })
  },
  mounted () {
    this.getUserDetails()
  },
  methods: {
    getPinCodeDetails (personal, pincode = '') {
      if (pincode.length === 6) {
        this.$store.dispatch('pinCode', { pincode, personal })
      }
    },
    startDMI () {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "KYC_ADDRESS_SUBMITTED",
        propertyName: "FILLED_USING",
        propertyValue: "MANUAL"
      });
      const query = JSON.parse(JSON.stringify(this.user))
      if (this.user.employmentDetail.workingSince) {
        query.employmentDetail.workingSince = new Date(
          `${query.employmentDetail.workingSince.slice(
            3,
            7
          )}-${query.employmentDetail.workingSince.slice(0, 2)}-01`
        )
      }
      !this.invalidPinCode && this.$store.dispatch('dmiStart', query)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupKycStep2/component.js